import React, { Component } from 'react';
import PropTypes from 'prop-types';

import widgetWrapper from './widgetWrapper';

import './BuildTileWidget.scss';

class BuildTileWidget extends Component {

  static propTypes = {
    masterNode: PropTypes.string,
    href: PropTypes.string,
    color: PropTypes.string,
    tabIndex: PropTypes.number,
    lastBuild: PropTypes.shape({
      number: PropTypes.number,
      url: PropTypes.string,
      result: PropTypes.string,
      fullDisplayName: PropTypes.string,
      building: PropTypes.bool,
      id: PropTypes.string,
      timestamp: PropTypes.number,
      description: PropTypes.arrayOf(PropTypes.string),
    }),
  };

  static defaultProps = {
    masterNode: '',
    href: '',
    color: '',
    tabIndex: 0,
    lastBuild: null,
  };

  render() {
    const {
      masterNode,
      href,
      color,
      tabIndex,
      lastBuild: {
        number,
        url,
        result,
        fullDisplayName,
        building,
        duration,
        timestamp = null,
        description,
      } = {},
    } = this.props;

    const startedDate = new Date(timestamp);
    const timeBuildStarted = `Started on ${startedDate.toLocaleDateString()} at ${startedDate.toLocaleTimeString()}`;
    return (
      <div
        className={`BuildTile ${color}`}
        role="button"
        tabIndex={tabIndex}
        onClick={(_e) => {
          window.open(href, '_blank');
        }}
        onKeyDown={(e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            window.open(href, '_blank');
          }
        }}
      >
        <div className="master-node">
          { masterNode }
        </div>
        {
          // eslint-disable-next-line no-nested-ternary
          fullDisplayName && fullDisplayName !== masterNode ? (
            url ? (
              <a className="project-name" target="_blank" href={url} tabIndex="-1" rel="noopener noreferrer">
                { fullDisplayName }
              </a>
            ) : fullDisplayName
          ) : <div />
        }
        <div className="build-number">
          LAST BUILD #&nbsp;
          {number}
        </div>
        <div>
          {timeBuildStarted}
        </div>
        {
          (building // eslint-disable-line no-nested-ternary
            ? <div>CURRENTLY RUNNING.</div>
            : (
              duration
                ? (
                  <div>
                    COMPLETED after&nbsp;
                    {
                      duration
                    }
                  </div>
                )
                : <div>COMPLETED.</div>))
        }
        <div>
          RESULT:&nbsp;
          {
            result
          }
        </div>
        <div className={(description && description.length > 0 ? 'description-box bordered' : 'DescriptionBox')}>
          {description.map(e => (
            <div dangerouslySetInnerHTML={{ __html: e }} />
          ))}
        </div>
      </div>
    );
  }
}

export default widgetWrapper(BuildTileWidget);
